const e = {
  "ld.startEditing": "开始编辑。",
  "ld.dashboard": "我的仪表板",
  "ld.search": "搜索",
  "ld.browse": "浏览",
  "ld.reset": "重置",
  "ld.searchResource": "搜索资源",
  "ld.create": "创建资源",
  "ld.edit": "编辑",
  "ld.editResource": "编辑资源",
  "ld.main": "主要的",
  "ld.and": "与",
  "ld.or": "或",
  "ld.not": "非",
  "ld.saveRd": "保存资源",
  "ld.closeRd": "关闭资源",
  "ld.deleteRd": "删除资源",
  "ld.resources": "资源",
  "ld.searchBy": "搜索方式",
  "ld.searchFor": "搜索",
  "ld.searchAndFilter": "搜索和筛选",
  "ld.enterSearchCriteria": "输入搜索条件开始搜索",
  "ld.chooseFilterOrEnterSearchQuery": "选择筛选条件或输入搜索查询以显示结果。",
  "ld.searchNoRdsMatch": "没有符合您查询的资源描述",
  "ld.searchBySth": "按{by}搜索...",
  "ld.errorFetching": "获取数据时出错",
  "ld.errorLoadingResource": "加载资源时出错",
  "ld.actions": "操作",
  "ld.isbnLccn": "ISBN/LCCN",
  "ld.isbn": "ISBN",
  "ld.lccn": "LCCN",
  "ld.lcnaf": "LC名称规范档",
  "ld.title": "题名",
  "ld.contributor": "贡献者",
  "ld.author": "作者",
  "ld.pubDate": "出版日期",
  "ld.pubDateShort": "出版日期",
  "ld.edition": "版本",
  "ld.select": "选择",
  "ld.subclass": "子类",
  "ld.heading": "标题",
  "ld.selectForEditing": "选择要编辑的资源描述",
  "ld.startFromScratch": "从头开始",
  "ld.selectOrStartFromScratch": "{select}或{startFromScratch}",
  "ld.backToTop": "返回顶部",
  "ld.preview": "预览",
  "ld.confirmCloseRd": "确实要关闭资源描述吗？所有未保存的更改都将丢失。",
  "ld.confirmDeleteRd": "确实要删除资源描述吗？",
  "ld.saveClose": "保存并关闭",
  "ld.close": "关闭",
  "ld.delete": "删除",
  "ld.return": "返回",
  "ld.rdSaveSuccess": "资源已创建。预计资源在 FOLIO 中可见之前会有短暂延迟。",
  "ld.rdUpdateSuccess": "资源已更新。更改在 FOLIO 中显示之前，预计会有短暂延迟。",
  "ld.cantSaveRd": "无法保存资源描述",
  "ld.cantDeleteRd": "无法删除资源描述",
  "ld.rdDeleted": "资源描述已删除",
  "ld.appFail": "发生错误。请重新加载页面。",
  "ld.searchSelectIndex": "请选择索引",
  "ld.advancedSearch": "高级搜索",
  "ld.advanced": "高级",
  "ld.cancel": "取消",
  "ld.loading": "载入中...",
  "ld.paginationCount": "{startCount} - {endCount}  : 共{totalResultsCount}",
  "ld.yes": "是",
  "ld.no": "否",
  "ld.cantLoadSimpleLookupData": "无法加载简单查找的数据",
  "ld.publishDate": "出版日期",
  "ld.format": "格式",
  "ld.suppressed": "已隐藏",
  "ld.notSuppressed": "未隐藏",
  "ld.volume": "卷",
  "ld.ebook": "电子书",
  "ld.allTime": "所有时间",
  "ld.past12Months": "过去 12 个月",
  "ld.past10Yrs": "过去 10 年",
  "ld.past5Yrs": "过去 5 年",
  "ld.customRange": "定制范围",
  "ld.all": "全部",
  "ld.onlineResource": "在线资源",
  "ld.startsWith": "始于",
  "ld.containsAll": "包含全部",
  "ld.exactPhrase": "精确短语",
  "ld.publisher": "出版者",
  "ld.creator": "创建者",
  "ld.language": "语言",
  "ld.classificationNumber": "分类号",
  "ld.work": "作品",
  "ld.instances": "实例",
  "ld.noInstancesAvailable": "无可用实例。",
  "ld.noInstancesAdded": "未添加实例",
  "ld.addAnInstance": "添加一个实例",
  "ld.type": "类型",
  "ld.expandAll": "全部展开",
  "ld.collapseAll": "全部收起",
  "ld.showAllWithCount": "显示全部 ( {amt} )",
  "ld.showAdditionalComponents": "显示其他组件 ( {amt} )",
  "ld.hideAdditionalComponents": "隐藏附加组件",
  "ld.hide": "隐藏",
  "ld.saveAndClose": "保存并关闭",
  "ld.saveAndContinue": "保存并继续",
  "ld.editInstance": "编辑实例",
  "ld.editWork": "编辑作品",
  "ld.createInstance": "创建实例",
  "ld.createWork": "创建作品",
  "ld.saveAndKeepEditing": "保存并继续编辑",
  "ld.recordMappingToSchema": "无法将记录应用到模式",
  "ld.newResource": "新资源",
  "ld.addInstance": "添加实例",
  "ld.compareSelected": "比较所选",
  "ld.newInstance": "新实例",
  "ld.newWork": "新作品",
  "ld.new": "新建",
  "ld.cantSelectReferenceContents": "获取参照时无法选择参照内容",
  "ld.addNewInstance": "添加新实例",
  "ld.askSaveChangesBeforeProceeding": "是否想在继续之前保存更改？",
  "ld.unsavedRecentEdits": "对资源所做的最新编辑尚未保存。未保存的更改将会丢失。",
  "ld.unsavedChanges": "未保存的更改",
  "ld.continueWithoutSaving": "退出而不保存",
  "ld.noTitleInBrackets": "无题名",
  "ld.viewMarc": "查看MARC",
  "ld.marcWithTitle": "MARC - {title}",
  "ld.cantLoadMarc": "无法加载此资源描述的 MARC",
  "ld.duplicate": "重复",
  "ld.viewLinkedData": "查看关联数据",
  "ld.viewInInventory": "在典藏应用中查看",
  "ld.authorityType": "规范类型",
  "ld.person": "个人",
  "ld.source": "来源",
  "ld.family": "家庭",
  "ld.organization": "组织",
  "ld.meeting": "会议",
  "ld.corporateBody": "团体",
  "ld.jurisdiction": "管辖地",
  "ld.conference": "会议",
  "ld.authorizedReference": "规范/参照",
  "ld.headingReference": "标题/参照",
  "ld.unauthorized": "非规范",
  "ld.assign": "分配",
  "ld.assignAuthority": "分配规范",
  "ld.change": "更改",
  "ld.searchCreatorAuthority": "搜索创建者规范",
  "ld.selectMarcAuthority": "选择MARC规范",
  "ld.marcAuthority": "MARC规范",
  "ld.keyword": "关键词",
  "ld.recordsFound": "找到{recordsCount}条记录",
  "ld.resourceWithIdIsEmpty": "资源描述{id}为空",
  "ld.duplicateInstance": "重复实例",
  "ld.duplicateWork": "重复作品",
  "ld.duplicateInstanceInBrackets": " : 重复实例 ) ",
  "ld.duplicateWorkInBrackets": " : 重复作品 ) ",
  "ld.identifierAll": "标识符 : 全部 ) ",
  "ld.personalName": "个人名称",
  "ld.corporateName": "团体/会议名称",
  "ld.geographicName": "地理名称",
  "ld.nameTitle": "名称-题名",
  "ld.uniformTitle": "统一题名",
  "ld.subject": "主题",
  "ld.childrensSubjectHeading": "儿童主题词表",
  "ld.genre": "体裁",
  "ld.authoritySource": "规范来源",
  "ld.references": "参考",
  "ld.thesaurus": "叙词表",
  "ld.typeOfHeading": "标头类型",
  "ld.dateCreated": "创建日期",
  "ld.dateUpdated": "更新日期",
  "ld.excludeSeeFrom": "排除参见自",
  "ld.excludeSeeFromAlso": "排除也见自",
  "ld.previous": "上一个",
  "ld.next": "下一个",
  "ld.from": "从",
  "ld.to": "到",
  "ld.apply": "应用",
  "ld.notSpecified": "未指定",
  "ld.externalResourcePreview": "外部资源预览",
  "ld.errorFetchingExternalResourceForPreview": "获取预览的外部资源时出错",
  "ld.fetchingExternalResourceById": "正在获取外部资源 id {resourceId}...",
  "ld.lastUpdated": "最后更新时间",
  "ld.marcAuthorityRecord": "MARC规范记录",
  "ld.selectBrowseOption": "选择浏览选项",
  "ld.searchQueryWouldBeHere": "{query}将在这里",
  "ld.continue": "继续",
  "ld.aria.filters.select": "选择搜索标识符",
  "ld.aria.filters.textbox": "搜索查询文本框",
  "ld.aria.filters.reset": "重置筛选按钮",
  "ld.aria.filters.reset.announce": "搜索字段和筛选已重置",
  "ld.backToInventory": "返回典藏",
  "ld.properties": "属性",
  "ld.errorFetchingExternalResourceForEditing": "获取外部资源进行编辑时出错",
  "ld.duplicateImportWarn": "重复导入警告",
  "ld.rdPropertiesMatchContinue": "此资源的属性与现有资源匹配。是否要继续？",
  "ld.instance": "实例",
  "ld.year": "年",
  "ld.aria.modal.close": "关闭{modalKind}模式",
  "ld.aria.advancedSearch.queryInput": "高级搜索行查询输入",
  "ld.aria.advancedSearch.operator": "高级搜索行运算符",
  "ld.aria.advancedSearch.qualifier": "高级搜索行限定符",
  "ld.aria.advancedSearch.identifier": "高级搜索行标识符",
  "ld.aria.listEntry.open": "打开可折叠列表条目",
  "ld.aria.listEntry.close": "关闭可折叠列表条目",
  "ld.aria.table.selectRow": "选择表格行",
  "ld.aria.sections.openResourcePreview": "打开资源预览部分",
  "ld.aria.sections.closeResourcePreview": "关闭资源预览部分",
  "ld.aria.edit.close": "关闭编辑页面",
  "ld.aria.edit.deleteComponent": "删除组件",
  "ld.aria.edit.duplicateComponent": "复制组件",
  "ld.aria.resourcePreview.close": "关闭资源预览面板",
  "ld.aria.externalResourcePreview.close": "关闭外部资源预览页面",
  "ld.aria.marcAuthorityPreview.close": "关闭 MARC 规范预览",
  "ld.aria.marcPreview.close": "关闭 MARC 预览模式",
  "ld.aria.complexLookup.marcPreview.close": "关闭查找 MARC 预览部分",
  "ld.aria.edit.removeComplexLookupFieldValue": "移除复杂的查找字段值",
  "ld.errorMakingApiRequest": "发出 API 请求时出错",
  "ld.compareResources": "比较资源",
  "ld.selectedResources": "已选资源",
  "ld.nResourcesSelected": "已选择{n}个资源",
  "ld.clearSelections": "清除选择",
  "ld.chooseTwoResourcesCompare": "选择两个或更多资源进行比较",
  "ld.chooseOneResourceCompare": "选择其他资源进行比较",
  "ld.aria.comparison.close": "关闭比较部分",
  "ld.aria.comparison.removeEntry": "移除比较条目",
  "ld.aria.searchPane.close": "关闭搜索面板",
  "ld.aria.searchPane.open": "打开搜索面板",
  "ld.modal.uncontrolledAuthoritiesWarning.title": "Uncontrolled authorities warning",
  "ld.modal.uncontrolledAuthoritiesWarning.body": `This description includes one or more uncontrolled authorities.
 Do you want to save changes?`,
  "ld.errorAssigningAuthority": "Error assigning authority",
  "ld.errorAssigningAuthority.not_valid_for_target": "Please select an authority with a resource type matching the edited authority field (e.g. LCNAF authority for the Creator field)",
  "ld.errorAssigningAuthority.no_lccn": "Only Library of Congress authorities can be assigned for now. This is temporary until additional source types are supported.",
  "ld.errorAssigningAuthority.unsupported_marc": "The selected authority isn't mapped to Linked Data, and can't be assigned yet. This is temporary, since MARC mapping is in progress.",
  "ld.required_primary_main_title": "Please add the main title in order to save.",
  "ld.lccn_does_not_match_pattern": "LCCN Pattern validation enabled: Please provide an LCCN that complies with standard structure.",
  "ld.lccn_not_unique": "LCCN uniqueness enabled: The LCCN you provided already exists. Please provide a different LCCN.",
  "ld.failed_dependency": "Unable to verify if LCCN is duplicated.",
  "ld.not_found": "The resource ID has been changed by another user while you had this resource open. Please refresh your browser’s window.",
  "ld.mapping": "There’s been a mapping issue. Please report this to your support team, with screenshots and a detailed account of what happened.",
  "ld.generic_bad_request": "There’s been a UI issue. Please report this to your support team, with screenshots and a detailed account of what happened.",
  "ld.server": "There’s been a server issue. Please report this to your support team, with screenshots and a detailed account of what happened.",
  "ld.already_exists": "The same resource ID already exists.",
  "ld.aria.sections.editInstance": "Edit instance: {title}"
};
export {
  e as default
};
